import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import MenuOptionsQuery from 'Query/MenuOptions.query';
import { ACCOUNT_LOGIN_URL, ACCOUNT_MENU_URL } from 'Route/MyAccount/MyAccount.config';
import {
    mapDispatchToProps,
    mapStateToProps,
    MenuContainer as SourceMenuContainer
} from 'SourceComponent/Menu/Menu.container';
import { isSignedIn } from 'Util/Auth';
import history from 'Util/History';
import { appendWithStoreCode } from 'Util/Url';

export {
    mapStateToProps,
    mapDispatchToProps
};

/** @namespace Elganso/Component/Menu/Container */
export class MenuContainer extends SourceMenuContainer {
    static propTypes = {
        ...this.propTypes,
        activeOption: PropTypes.number
    };

    __construct(props) {
        super.__construct(props, 'MenuContainer');

        this.state = {
            ...this.state,
            isLoading: true,
            menuYB: true,
            padres: [],
            noPadres: [],
            imagesPadres: [],
            catHijaPadreMostrada: null
        };
    }

    containerFunctions = {
        ...this.containerFunctions,
        clickCatPadre: this.clickCatPadre.bind(this),
        clickItem: this.clickItem.bind(this),
        clickExpandable: this.clickExpandable.bind(this),
        onSignInAccountButtonClick: this.onSignInAccountButtonClick.bind(this)
    };

    componentDidMount() {
        super.componentDidMount();

        this.getMenuOptions();

        if (document.getElementsByClassName('Menu-Padres')[0]) {
            document.getElementsByClassName('Menu-Padres')[0].scrollIntoView({ block: 'start' });
        }
    }

    containerProps() {
        const {
            menuYB, padres, noPadres, imagesPadres, isLoading, catHijaPadreMostrada
        } = this.state;

        const actualItem = window.sessionStorage.getItem('actualItem');

        return {
            isLoading,
            menuYB,
            padres,
            noPadres,
            imagesPadres,
            catHijaPadreMostrada,
            activeOption: actualItem ? parseInt(actualItem, 10) : 0,
            activeExpandable: window.sessionStorage.getItem('actualExpandable'),
            ...super.containerProps()
        };
    }

    closeMenu() {
        // Quitamos el resto de funcionalidad para que no se cierre el item del menu al quitar el raton.
    }

    getMenuOptions() {
        const { activeOption, device } = this.props;
        const { catHijaPadreMostrada } = this.state;

        this.fetchData(
            [MenuOptionsQuery.getOptionsQuery()],
            (result) => {
            // SACAMOS CAT PADRES
                const padres = [];
                let i = 0;
                let primeraCatPadre = null;
                let existeCatSession = false;

                result.getMenuOptions.padres.forEach((element) => {
                    const cat = JSON.parse(element);
                    padres.push(cat);

                    const padreActual = window.sessionStorage.getItem('actualPadre');

                    if (padreActual && !catHijaPadreMostrada && (activeOption || device.isMobile)) {
                        this.setState({ catHijaPadreMostrada: padreActual });
                        i++;
                    } else if (i === 0) {
                        window.sessionStorage.setItem('actualItem', null);
                        window.sessionStorage.setItem('actualPadre', cat.item_id);
                        this.setState({ catHijaPadreMostrada: cat.item_id });
                        i++;
                    }

                    // Comprobamos que alguna de las categorias coincida con la que tenemos en el sessionStorage
                    if (!existeCatSession && cat.item_id === padreActual) {
                        existeCatSession = true;
                    }

                    // Guardamos el id de la primera categoria
                    if (primeraCatPadre === null) {
                        primeraCatPadre = cat.item_id;
                    }
                });
                this.setState({ padres });

                // Si el sessionStorage que hay guardado no corresponde con ningun id cambiamos la padre a mostrar por la primera cat del menu
                if (!existeCatSession) {
                    window.sessionStorage.setItem('actualPadre', primeraCatPadre);
                    this.setState({ catHijaPadreMostrada: primeraCatPadre });
                }

                // SACAMOS CAT NO PADRES
                const noPadres = [];
                result.getMenuOptions.noPadres.forEach((element) => {
                    noPadres.push(JSON.parse(element));
                });
                this.setState({ noPadres });

                // SACAMOS IMAGENES CAT PADRES
                const imagesPadres = [];
                result.getMenuOptions.imagesPadres.forEach((element) => {
                    imagesPadres.push(JSON.parse(element));
                });
                this.setState({ imagesPadres });

                // COMPROBAMOS PARA SACAR NUESTRO MENU O EL DE SCANDI
                if (padres.length === 0 && noPadres.length === 0) {
                    this.setState({ menuYB: false });
                }

                this.setState({ isLoading: false });
            }
        );
    }

    clickCatPadre(idNuevo) {
        window.sessionStorage.setItem('actualPadre', idNuevo);

        this.setState({ catHijaPadreMostrada: idNuevo });
    }

    clickItem(idNuevo) {
        window.sessionStorage.setItem('actualItem', idNuevo);
    }

    clickExpandable(idNuevo) {
        window.sessionStorage.setItem('actualExpandable', idNuevo);
    }

    onSignInAccountButtonClick() {
        if (isSignedIn()) {
            history.push({ pathname: appendWithStoreCode(ACCOUNT_MENU_URL) });
        } else {
            history.push({ pathname: appendWithStoreCode(ACCOUNT_LOGIN_URL) });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
